import { css } from 'styled-components';
import { isValidThemePath } from '../../foundation/theme/isValidThemePath.js';
import { valueGuard } from './valueGuard.js';
import { cssPropertyThemeKey } from './cssPropertyToThemeKey.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../foundation/breakpoints/values.js';

/**
 * media query helper. Styles will be applied to the breakpoint and larger.
 *
 * `base` is the default and will apply where no breakpoint matches.
 *
 * @example
 * responsiveProperty('padding', '1rem');
 *
 * responsiveProperty('padding', {
 *   base: `0`,
 *   sm: `1rem`,
 *   lg: `2rem`,
 * });
 *
 */
function responsiveProperty(property, values) {
  if (!values) {
    return css([""]);
  }
  var mappableValues = valueGuard(values);
  var themePath = cssPropertyThemeKey(property);
  var arrayValues = Object.entries(mappableValues).reduce(function (acc, _ref) {
    var _breakpoint, _Object$assign2;
    var key = _ref[0],
      value = _ref[1];
    var path = themePath + "." + value;
    var isThemePath = isValidThemePath(path);
    var cssValue = isThemePath ? themeGet(path) : value;
    if (key === 'base') {
      var _Object$assign;
      return Object.assign(Object.assign({}, acc), (_Object$assign = {}, _Object$assign[property] = cssValue, _Object$assign));
    }
    var breakpoint = breakpoints[key];
    return Object.assign(Object.assign({}, acc), (_Object$assign2 = {}, _Object$assign2[breakpoint] = (_breakpoint = {}, _breakpoint[property] = cssValue, _breakpoint), _Object$assign2));
  }, {});
  return css(arrayValues);
}

export { responsiveProperty };
